import { useMutation, useQuery, useQueryClient } from 'react-query'
import z from 'zod'
import type { DepartmentUser } from '~/types/department.types'
import type { User } from '~/types/user.types'
import httpClient from '~/utils/httpClient'

export const userSchema = z.object({
  email: z.email('invalid email address'),
  name: z.string('name is required').min(4, 'name should be minimal 4 characters'),
  role: z
    .number('must be valid number')
    .min(1, 'expected number between 1 and 4')
    .max(4, 'expected number between 1 and 4'),
  departments: z
    .array(
      z.object({ departmentId: z.number().optional(), role: z.number().min(1).max(2).optional() }),
    )
    .optional(),
})
export const userSchemaSubmission = z.object({
  email: z.email('invalid email address'),
  name: z.string('name is required').min(4, 'name should be minimal 4 characters'),
  role: z
    .number('must be valid number')
    .min(1, 'expected number between 1 and 4')
    .max(4, 'expected number between 1 and 4'),
  departments: z
    .array(z.object({ departmentId: z.number(), role: z.number().min(1).max(2) }))
    .optional(),
})

export const useUsersList = () => {
  const q = useQuery({
    queryKey: ['users'],
    queryFn: async () => {
      const response = await httpClient.get<{
        data: (User & { departments?: (Omit<DepartmentUser, 'userId'> & { title: string })[] })[]
      }>('/api/users')
      return response?.data.data
    },
  })
  return q
}
export const useSyncUserMutation = () => {
  const client = useQueryClient()
  const q = useMutation({
    mutationFn: async (
      reqObj: Pick<User, 'email' | 'name' | 'role'> & {
        departments?: Omit<DepartmentUser, 'userId'>[]
      },
    ) => {
      const response = await httpClient.put<{
        data: (User & { departments?: Omit<DepartmentUser, 'userId'>[] })[]
      }>('/api/users', reqObj)
      return response?.data.data
    },
    onSuccess: () => {
      client.invalidateQueries(['users'])
    },
  })
  return q
}
